<script>
import { Bar } from 'vue-chartjs'

export default {
  extends: Bar,
  props: {
    data: {
      type: Array,
      required: true
    },
    labels: {
      type: Array,
      required: true
    }
  },
  mounted () {
    this.renderChart({
          datasets: [{
            data: this.data,
            backgroundColor: this.getColors(),
          }],
          labels: this.labels,
        },
        {
          scales: {
            yAxes: [{
              ticks: {
                beginAtZero: true
              }
            }]
          },
          legend: {
            display: false
          },
        })
  }
}
</script>
